export const API_URL = process.env.REACT_APP_API_URL
export const SENTRY_KEY = process.env.REACT_APP_SENTRY_AUTH_TOKEN;
export const SENSOR_API_URL = process.env.REACT_APP_SENSOR_API_URL;
